import  { insecuredHttpClient, httpClient } from './httpClient';

const END_POINT = '/auth';


export const auth = {
    login({ name, password }) { return insecuredHttpClient.post(`${END_POINT}/login`, { name, password }) },
    myInfo() {
        return httpClient.get(`${END_POINT}/me`)
    }
}
